import * as utils from './utils'
window.system = {}

system = {
  /**
   * 当前路由
   */
  routerBase: process.env.BASE_URL,
  /**
   * 首页的默认地址
   */

  mainIsLogin: true,
  /**
   * 当前应用的基本配置信息
   */
  app: {}
  /**
   * 文件上传变量
   */
}

var gtwtemp = localStorage.getItem('_gtw')
setenv(gtwtemp == null ? process.env.NODE_ENV : gtwtemp)

function setenv(env) {
  console.log(env)
  switch (env) {
    case 'development': //研发环境
    case 'dev': //研发环境镜像
      system.env = 'dev'
      system.app.api = 'https://wj-api-dev.xxzy.link'
      break
    case 'test': //测试环境
      system.env = 'test'
      system.app.api = 'https://wj-api-test.xxzy.link'
      // system.app.api = 'http://192.168.2.8:8081' //本地
      break
    // case 'beta': //测试环境
    //   system.env = 'beta'
    //   system.app.api = 'https://wj-api-test.xxzy.link'
    //   break
    case 'production': //生产环境
      system.env = 'prod'
      system.app.api = 'https://api.5j56.com'
      break
  }
}

var tokenIntervalId = null

window.onload = function () {
  var link = document.querySelector("link[rel*='icon']") || document.createElement('link')
  link.type = 'image/x-icon'
  link.rel = 'shortcut icon'
  if (_global_.UI) {
    link.href = _global_.UI.logo
    document.getElementsByTagName('head')[0].appendChild(link)
    document.title = _global_.UI.title
  }
  if (process.env.NODE_ENV != 'production') {
    if (system.token) {
      utils.refreshLoginInfo((data) => {
        setDebugPlan(data)
      })
    } else {
      setDebugPlan(null)
    }
  }
}

function setDebugPlan(data) {
  var body = ''
  body += "<div style='display:flex;border-left:2px solid #0088f5;padding-left:10px;line-height:1;margin-bottom:10px;'><span style='flex:1;font-size:16px;color:#333'>网关信息</span><span onclick=switchEnv('hide') style='font-size:16px;color:#0088f5;cursor:pointer'>关闭</span></div>"
  body += "<span style='color:#333'>API：</span>" + system.app.api
  body += "<br/><span style='color:#333'>Core Version：</span>" + system.app.coreVersion
  body += "<br/><span style='color:#333'>Self Version：</span>" + system.app.version

  body += '<br/>'
  if (data) {
    body += "<br/><div style='display:flex;border-left:2px solid #0088f5;padding-left:10px;line-height:1;margin-bottom:10px;font-size:16px;color:#333'>用户信息</div>"
    body += "<span style='color:#333'>UserName：</span>" + data.user_name
    body += "<br/><span style='color:#333'>Type：</span>" + data.type
    body += "<br/><span style='color:#333'>RoleCodes：</span>" + data.role_codes
    body += "<br/><span style='color:#333'>Groups：</span>" + data.groups
    body += "<br/><span style='color:#333'>Roles：</span>" + data.roles
  }

  body += '<br/>'

  body += "<br/><div style='display:flex;border-left:2px solid #0088f5;padding-left:10px;line-height:1;margin-bottom:10px;font-size:16px;color:#333'>系统环境</div>"

  body += "<span style='color:#0088f5;cursor:pointer' onclick=switchEnv('dev','研发环境')>研发环境</span>&nbsp;&nbsp;&nbsp;"
  // body += "<span style='color:#0088f5;cursor:pointer' onclick=switchEnv('beta','灰度环境')>灰度环境</span>&nbsp;&nbsp;&nbsp;"
  body += "<span style='color:#0088f5;cursor:pointer' onclick=switchEnv('test','测试环境')>测试环境</span>&nbsp;&nbsp;&nbsp;"

  body += '<br/>'

  var bg = ''
  if (system.env == 'dev') {
    bg = 'background-color:#CBAFF8'
    document.title = '研发环境::' + document.title
  }
  if (process.env.NODE_ENV == 'dev') {
    bg = 'background-color:rgb(120, 33, 117)'
    document.title = '研发环境镜像::' + document.title
  }
  if (system.env == 'test') {
    bg = 'background-color:#2b8ce1'
    document.title = '测试环境::' + document.title
  }
  if (system.env == 'beta') {
    bg = 'background-color:#668F99'
    document.title = '灰度环境::' + document.title
  }

  var html =
    '<div id="_version_plan_" style="z-index:10000;position:absolute;right:0;bottom:0;margin-bottom:10px;margin-right:10px;width:360px;height:355px;background-color:#fff;border:1px dashed #e5e5e5;box-shadow:0 0 15px rgba(0,0,0,.1);"><div id="_version_plan_body_" style="line-height:1.5;color:#888;padding:20px">' +
    body +
    '</div><div id="_version_plan_info_" style="font-size:10px;text-align:center;display:none;height: 38px; line-height: 38px;' +
    bg +
    '">' +
    system.env +
    '</div></div>'

  var wrap = document.createElement('div')

  wrap.onclick = function () {
    document.getElementById('_version_plan_body_').style.display = ''
    document.getElementById('_version_plan_info_').style.display = 'none'
    var plan = document.getElementById('_version_plan_')
    plan.style.width = '360px'
    plan.style.height = '355px'
  }
  if ((data != null && check()) || system.env != 'prod') {
    wrap.innerHTML = html
    var first = document.body.firstChild
    document.body.insertBefore(wrap, first)
    switchEnv('hide')
  }
}

function check() {
  var userAgentInfo = navigator.userAgent
  var Agents = new Array('Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod')
  var flag = true
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false
      break
    }
  }
  return flag
}

/**
 * 主动切换环境
 */
window.switchEnv = function switchEnv(tag, obj) {
  event.stopPropagation()
  if (tag == 'hide') {
    document.getElementById('_version_plan_body_').style.display = 'none'
    document.getElementById('_version_plan_info_').style.display = ''
    var plan = document.getElementById('_version_plan_')
    plan.style.width = '40px'
    plan.style.height = '38px'
  } else {
    localStorage.setItem('_gtw', tag)
    window.location.reload()
  }
}

// if (system.env == 'prod') {
//   console.log = () => { }
// }



// WEBPACK FOOTER //
// ./src/assets/js/config.js